module.exports = __webpack_public_path__ + "img/EgyptTechElephantArcherS_ua.76c83165.webp";